// extracted by mini-css-extract-plugin
module.exports = {"registration-form":"RegistrationForm_registration-form__1rLDt","form":"RegistrationForm_form__3BilV","logo":"RegistrationForm_logo__3_hEq"};